/*
/*
* Pipeline Theme - Custom JS
*/

(function() {

  document.addEventListener('theme:cart:change', function(event) {
    var cart = event.detail.cart;
    if (!cart) return;

    // Update cart total in checkout button and header bar
    document.querySelectorAll('[data-cart-final]').forEach(function(el) {
      el.textContent = formatMoney(cart.total_price);
    });

    // Update individual line item totals
    document.querySelectorAll('[data-cart-item]').forEach(function(itemEl, index) {
      var item = cart.items[index];
      if (item) {
        var totalEl = itemEl.querySelector('.cart__items__total');
        if (totalEl) {
          totalEl.textContent = formatMoney(item.final_line_price);
        }
      }
    });
  });

  function formatMoney(cents) {
    var value = (cents / 100).toFixed(2);
    var currency = window.Shopify && window.Shopify.currency && window.Shopify.currency.active
      ? window.Shopify.currency.active
      : 'USD';
    return currency + ' $' + value.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

})();
